<!--<template>-->
<!--  <div>-->
<!--    &lt;!&ndash; 标题 &ndash;&gt;-->
<!--    <h3 v-if="title">{{ title }}</h3>-->
<!--    &lt;!&ndash; TAB目录 &ndash;&gt;-->
<!--    <Row-->
<!--      :gutter="8"-->
<!--      style="margin: 0px 0 0 0; width: 100%"-->
<!--      v-if="menus && menus.length > 0"-->
<!--    >-->
<!--      <Menu-->
<!--        mode="horizontal"-->
<!--        :active-name="menu_name"-->
<!--        @on-select="selectMenu"-->
<!--        style="width: 100%"-->
<!--      >-->
<!--        <div v-for="(v, k) in menus" :key="k">-->
<!--          <MenuItem :name="v.name" v-auth="v.auth" @click="v.onClick">-->
<!--            <Badge-->
<!--              :overflow-count="10000000"-->
<!--              v-if="v.badge && v.badge.count"-->
<!--              :offset="[18, -3]"-->
<!--            >-->
<!--              {{ v.label }}-->
<!--            </Badge>-->
<!--            <span v-if="!(v.badge && v.badge.count)">-->
<!--              {{ v.label }}-->
<!--            </span>-->
<!--          </MenuItem>-->
<!--        </div>-->
<!--      </Menu>-->
<!--    </Row>-->
<!--    &lt;!&ndash; 操作 &ndash;&gt;-->
<!--    <Row-->
<!--      :gutter="8"-->
<!--      style="margin: 20px 0 0 0; width: 100%"-->
<!--      v-if="actions && actions.length > 0"-->
<!--    >-->
<!--      <div-->
<!--        v-for="(v, k) in actions"-->
<!--        :key="k"-->
<!--        style="margin-right: 10px; display: inline-flex"-->
<!--      >-->
<!--        &lt;!&ndash; <Col span="3" :xxl="3" :xl="4" :lg="6" :md="8" :sm="12" :xs="12" v-auth="v.auth"> &ndash;&gt;-->
<!--        <Button-->
<!--          :size="v.size || 'default'"-->
<!--          :type="v.type || 'warning'"-->
<!--          v-auth="v.auth"-->
<!--          :icon="v.icon || ''"-->
<!--          @click="v.onClick"-->
<!--          >{{ v.label }}</Button-->
<!--        >-->
<!--        &lt;!&ndash; </Col> &ndash;&gt;-->
<!--      </div>-->
<!--    </Row>-->

<!--    <ul class="Ul">-->
<!--      <li v-for="item in arr" :key="item.id" @click="btn(item.id)">-->
<!--       &lt;!&ndash;  <img-->
<!--          :src="item.imgUrl"-->
<!--          alt=""-->
<!--          v-show="item.imgUrl == null ? false : true"-->
<!--        /> &ndash;&gt;-->
<!--        <h3>{{ item.name }}</h3>-->
<!--        <div :style="{ left: item.imgUrl == null ? '0px' : '170px' }">-->
<!--          <p v-html="item.content">{{ item.content }}</p>-->
<!--        </div>-->
<!--      </li>-->
<!--    </ul>-->
<!--    &lt;!&ndash; 动态组件 &ndash;&gt;-->
<!--    <component-->
<!--      v-for="(item, index) in extRender || []"-->
<!--      :key="index"-->
<!--      :ref="item"-->
<!--      :is="item"-->
<!--    ></component>-->
<!--  </div>-->
<!--</template>-->
<template>
  <div v-if="width && height" :style="{
    width:`${width}px`,
    height:`${height}px`
  }">
    <Iframe
        :url="url"
        :Authorization="Authorization"
        :customerId="customerId"
        class="iframe1" id="iframe1">
    </Iframe>
  </div>
</template>
<script>
import Viewport from '@/utils/viewport' ;
import Iframe from "@/views/components/base/Iframe";
// import baseList from "@/views/components/base/baseList.vue";
export default {
  // extends: baseList,
  name: 'knowledgeBase',
  components: {
    Iframe
  },
  data() {
    return {
      url:null,
      Authorization:null,
      customerId:null,
      width:null,
      height:null
      // table: {
      //   mname: "knowledge",
      //   key: "id",
      //   url: {
      //     del: "/admin/system/knowledge",
      //   },
      //   output: false,
      //   order: "createTime",
      // },
      // actions: [
      //   {
      //     label: "新增",
      //     icon: "md-add",
      //     onClick: this.toAdd,
      //     type: "info",
      //     auth: "system/knowledgeBase/add",
      //   },
      // ],
      // menus: [
      //   // {
      //   //   label: "知识库",
      //   //   name: "knowledgeBase_list",
      //   //   auth: "system/knowledgeBase/index",
      //   // },
      //   // {
      //   //   label: "知识库分类",
      //   //   name: "knowledgeBaseClass_list",
      //   //   auth: "system/knowledgeBaseClass/index",
      //   // },
      //   // {
      //   //   label: "知识库标签",
      //   //   name: "knowledgeBaseTag_list",
      //   //   auth: "system/knowledgeBaseTag/index",
      //   // },
      // ],
      // arr: [],
    };
  },
  // created() {
  //   this.loadLevelData();
  //   this.loadLableData();
  // },
  mounted() {
    const me = this ;

    me.Authorization = global.$utils.data.get("","token");
    me.customerId =window.localStorage.getItem("customerId");
    //  me.url = 'http://localhost:8080' ;

      me.url = 'https://hkzsk.hi-eweibao.com'
    console.log(this.url)
    this.viewport = new Viewport(this);
  },
  destroyed() {

    this.viewport.onDestroyed() ;

  },

};
</script>

